import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux'
import { dispatch } from '../../../../utils/store'
import { Actions } from '../../../../redux/actions'
import { CardHeader, Nav, NavItem, NavLink, TabContent, TabPane, Button, Table, Card, CardBody, CardTitle, CardText, Row, Col, Collapse, FormGroup, Label, Input } from "reactstrap";
import classnames from "classnames";
import { getPayouts, exportPayout, addOrganization, getOrganization, updateOrganization } from "../../utils/middleware/payouts";
import { getEvent } from "../../utils/middleware/events";
import moment from "moment-timezone";
import Select from 'react-select';
import Papa from "papaparse";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";

const Finance = () => {
    const [activeTab, setActiveTab] = useState("1");
    const [expandedRow, setExpandedRow] = useState(null);
    const [organizationType, setOrganizationType] = useState("individual");
    const [organizationName, setOrganizationName] = useState(null);
    const [organizationEmail, setOrganizationEmail] = useState(null);
    const [website, setWebsite] = useState(null);
    const [description, setDescription] = useState(null);
    const [facebookLink, setFacebookLink] = useState(null);
    const [instagramLink, setInstagramLink] = useState(null);
    const [organizationPhone, setOrganizationPhone] = useState(null);
    const [addCountry, setAddCountry] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null)
    const [loading, setLoading] = useState(false);

    const { payouts, search, organization, startDate, endDate, activeSort, sortOrder, totalCount, page } = useSelector(state => state.restaurantAdminPayouts)
    const { eventList } = useSelector(state => state.restaurantAdminEvents)
    const { pageSize } = useSelector(state => state.user)

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const copyLink = (date) => {
        const url = `${window.location.origin}/organization/${organizationName}/${organization.restaurantId}`
        navigator.clipboard.writeText(url)
          .then(() => toast.info("URL copied to clipboard!", {
            position: "bottom-right",
            theme: "colored",
          }))
          .catch(err => console.error("Failed to copy: ", err));
      };

    const handleChange = (selected) => {
        if (selected !== null) {
            getPayouts({ id: selected.value });
        }
        setSelectedOption(selected);
    };

    const handleExport = async () => {
        setLoading(true);
        try {
            exportPayout().then(result => {
                result = result.data.data.map(({ eventName, payoutDate, amount, payoutMethod, expectedArrivalDate }) => ({
                    "Event name": eventName,
                    "Payout date": payoutDate,
                    "Amount": amount,
                    "Payout method": payoutMethod,
                    "Expected arrival date": expectedArrivalDate
                  }));
                if (result.length > 0) {
                    // Convert data to CSV format
                    const csv = Papa.unparse(result);
                    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

                    // Save file
                    saveAs(blob, "exported_data.csv");
                } else {
                    toast.warn("No data available to export.", {
                        position: "bottom-right",
                        theme: "colored",
                    });
                }    
            })
            
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.warn("Failed to fetch data!", {
                position: "bottom-right",
                theme: "colored",
            });
        }
        setLoading(false);
    };

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    useEffect(() => {
        getOrganization();
        let pageCount = Math.ceil(totalCount / pageSize)
        if (totalCount && page > pageCount) {
            dispatch(Actions.RestaurantAdminPayouts.SetPage, pageCount)
        }
        if (selectedOption === null) {
            payouts.length = 0;
        }
        getEvent({ search, sortBy: activeSort, orderBy: sortOrder, page })
    }, [])

    useEffect(() => {
        if (organization) {
            setOrganizationName(organization?.name)
            setOrganizationEmail(organization?.email)
            setWebsite(organization?.websiteLink)
            setDescription(organization?.description)
            setFacebookLink(organization?.facebookLink)
            setInstagramLink(organization?.instagramLink)
            setOrganizationPhone(organization?.phone)
        }

    }, [organization])

    const addOrganizationData = async () => {
        // Validate required fields
        if (!organizationName || !organizationEmail) {
            toast.error("Organization Name and Email are required!", {
                position: "bottom-right",
                theme: "colored",
            });
            return;
        }
        const restaurant = JSON.parse(localStorage.getItem("userData"));
        const userRestaurantId = restaurant.restaurantId;
        // Create the payload
        const payload = {
            id: organization?.id, // Assuming ID is auto-generated, you can modify it as needed
            restaurantId: userRestaurantId, // Replace with the actual restaurantId
            name: organizationName,
            email: organizationEmail,
            phone: organizationPhone, // Replace with the actual phone number if available
            description: description || "",
            facebookLink: facebookLink || "",
            instagramLink: instagramLink || "",
            linkedinLink: "", // If you have a state for LinkedIn, replace this
            websiteLink: website || "",
        };
        if (organization?.id && organization?.id !== null) {
            updateOrganization(payload);
        } else {
            addOrganization(payload);
        }

    };


    return (
        <div>
            <div className="custom-container">
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0 space-between-div table-header-div">
                                <h3 className="mb-0">Finance</h3>
                                <div className="right-div-wrap">
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="Select an Event..."
                                        value={selectedOption}
                                        onChange={handleChange}
                                        isClearable={true}
                                        isSearchable={true}
                                        name="eventName"
                                        options={eventList}
                                    />
                                </div>
                            </CardHeader>

                            {/* Navigation Tabs */}
                            <Nav tabs className="mt-3">
                                <NavItem>
                                    <NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggle("1")} >
                                        Payouts
                                    </NavLink>
                                </NavItem>
                                {/* <NavItem>
                        <NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggle("2")} >
                        Charges & Credits
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === "3" })} onClick={() => toggle("3")} >
                            Invoices
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === "4" })} onClick={() => toggle("4")} >
                            Settings
                        </NavLink>
                    </NavItem> */}
                                <NavItem>
                                    <NavLink className={classnames({ active: activeTab === "5" })} onClick={() => toggle("5")} >
                                        Organization Profile
                                    </NavLink>
                                </NavItem>
                            </Nav>

                            {/* Tab Content */}
                            <TabContent activeTab={activeTab} className="mt-3">
                                <TabPane tabId="1">
                                    <Card>
                                        <CardBody>
                                            <Row>
                                                {/* <Col md={2}> */}
                                                {/* <Button color="primary" className="w-100">
                                                        Summary
                                                    </Button> */}
                                                {/* <Button color="light" className="w-100 mt-2">
                                                        Upcoming
                                                    </Button>
                                                    <Button color="light" className="w-100 mt-2">
                                                        Exports
                                                    </Button> */}
                                                {/* </Col> */}
                                                <Col md={12}>
                                                    <div className="d-flex justify-content-between">
                                                        {/* <div>
                                                            <Button color="primary" className="me-2">
                                                                By Payout Date
                                                            </Button>
                                                            <Button color="light">By Event Date</Button>
                                                        </div> */}
                                                        <div className="right-div-wrap">
                                                            <button onClick={handleExport} disabled={loading} className="btn btn-primary">
                                                                {loading ? "Fetching & Exporting..." : "Export CSV"}
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {/* Payout Table */}
                                                    <Table bordered hover className="mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th>Payout Date</th>
                                                                <th>Amount</th>
                                                                <th>Event</th>
                                                                <th>Payout Method</th>
                                                                <th>Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {payouts.map((payout, index) => (
                                                                <React.Fragment key={index}>
                                                                    {/* Main Row */}
                                                                    <tr
                                                                        onClick={() => toggleRow(index)}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <td>
                                                                            <strong>{payout.payoutDate}</strong>
                                                                        </td>
                                                                        <td>{payout.amount}</td>
                                                                        <td>{payout.eventName}</td>
                                                                        <td>{payout.payoutMethod}</td>
                                                                        <td>
                                                                            <Button color="success" size="sm">
                                                                                {payout.status ? " ✔ Sent" : "Pending"}
                                                                            </Button>
                                                                        </td>
                                                                    </tr>

                                                                    {/* Collapsible Details Row */}
                                                                    <tr>
                                                                        <td colSpan="5" className="p-0">
                                                                            <Collapse isOpen={expandedRow === index}>
                                                                                <Card className="m-0 border-0">
                                                                                    <CardBody className="bg-light">
                                                                                        <Row>
                                                                                            <Col md={6}>
                                                                                                <p>
                                                                                                    <strong>Payout Type:</strong>{" "}
                                                                                                    {payout.payoutType}
                                                                                                </p>
                                                                                                {/* <p>
                                                    <strong>Payout ID:</strong>{" "}
                                                    {payout.details.payoutId}
                                                    </p> */}
                                                                                                <p>
                                                                                                    <strong>Event Name:</strong>{" "}
                                                                                                    {payout.eventName}
                                                                                                </p>
                                                                                            </Col>
                                                                                            <Col md={6}>
                                                                                                <p>
                                                                                                    <strong>Initiated Date:</strong>{" "}
                                                                                                    {payout.initiatedDate}
                                                                                                </p>
                                                                                                <p>
                                                                                                    <strong>Expected Arrival Date:</strong>{" "}
                                                                                                    {payout.expectedArrivalDate}
                                                                                                </p>
                                                                                            </Col>
                                                                                        </Row>
                                                                                        <Row className="mt-2">
                                                                                            <Col md={6}>
                                                                                                <p>
                                                                                                    <strong>Net Sales:</strong>{" "}
                                                                                                    {payout.netSales}
                                                                                                </p>
                                                                                                <p>
                                                                                                    <strong>Charges:</strong>{" "}
                                                                                                    {payout.chargesAndCredits}
                                                                                                </p>
                                                                                            </Col>
                                                                                            <Col md={6}>
                                                                                                <p>
                                                                                                    <strong>Paid Out:</strong>{" "}
                                                                                                    {payout.paidOut}
                                                                                                </p>
                                                                                            </Col>
                                                                                        </Row>
                                                                                        {/* <div className="text-end">
                                                <Button color="link">CSV</Button>
                                                <Button color="link">PDF</Button>
                                                </div> */}
                                                                                    </CardBody>
                                                                                </Card>
                                                                            </Collapse>
                                                                        </td>
                                                                    </tr>
                                                                </React.Fragment>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </TabPane>

                                <TabPane tabId="2">
                                    <Card>
                                        <CardBody>
                                            <h5>Charges & Credits</h5>
                                            <p>Details will be displayed here.</p>
                                        </CardBody>
                                    </Card>
                                </TabPane>

                                <TabPane tabId="3">
                                    <Card>
                                        <CardBody>
                                            <h5>Invoices</h5>
                                            <p>Invoice details will be displayed here.</p>
                                        </CardBody>
                                    </Card>
                                </TabPane>

                                <TabPane tabId="4">
                                    <Card className="p-3">
                                        <CardBody>
                                            <CardTitle tag="h5">Manage Your Payout Schedule</CardTitle>
                                            <CardText>Choose how often you want to receive payouts.</CardText>
                                        </CardBody>
                                    </Card>
                                </TabPane>

                                <TabPane tabId="5">
                                    <Card>
                                        <CardBody>
                                            {/* Organization Type */}
                                            <FormGroup tag="fieldset">
                                                <Label className="d-block">Organization Type <span className="text-danger">*</span></Label>
                                                <FormGroup check inline>
                                                    <Label check>
                                                        <Input
                                                            type="radio"
                                                            name="orgType"
                                                            checked={organizationType === "individual"}
                                                            onChange={() => setOrganizationType("individual")}
                                                        />
                                                        Individual
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check inline>
                                                    <Label check>
                                                        <Input
                                                            type="radio"
                                                            name="orgType"
                                                            checked={organizationType === "company"}
                                                            onChange={() => setOrganizationType("company")}
                                                        />
                                                        Company
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check inline>
                                                    <Label check>
                                                        <Input
                                                            type="radio"
                                                            name="orgType"
                                                            checked={organizationType === "nonprofit"}
                                                            onChange={() => setOrganizationType("nonprofit")}
                                                        />
                                                        Nonprofit
                                                    </Label>
                                                </FormGroup>
                                            </FormGroup>

                                            {/* Name & DOB */}
                                            <Row>
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="organizationName">Organization Name <span className="text-danger">*</span></Label>
                                                        <Input type="text" value={organizationName} onChange={(e) => setOrganizationName(e.target.value)} id="organizationName" placeholder="Enter organization name" />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="organizationEmail">Organization Email <span className="text-danger">*</span></Label>
                                                        <Input type="text" id="organizationEmail" value={organizationEmail} onChange={(e) => setOrganizationEmail(e.target.value)} placeholder="Enter organization email" />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="organizationPhone">Organization Contact <span className="text-danger">*</span></Label>
                                                        <Input type="text" id="organizationPhone" value={organizationPhone} onChange={(e) => setOrganizationPhone(e.target.value)} placeholder="Enter organization email" />
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <FormGroup>
                                                <Label for="description">Organization Description <span className="text-danger">*</span></Label>
                                                <Input type="textarea" id="description" value={description} onChange={(e) => setDescription(e.target.value)} />
                                            </FormGroup>

                                            {/* Organization Website */}
                                            <Row>
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="website">Organization Instagram URL</Label>
                                                        <Input type="url" id="website" value={instagramLink} onChange={(e) => setInstagramLink(e.target.value)} placeholder="https://example.com" />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="website">Organization Facebook URL</Label>
                                                        <Input type="url" id="website" value={facebookLink} onChange={(e) => setFacebookLink(e.target.value)} placeholder="https://example.com" />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="website">Organization Website</Label>
                                                        <Input type="url" id="website" value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="https://example.com" />
                                                    </FormGroup>
                                                </Col>

                                            </Row>

                                            {/* Address Fields */}
                                            {/* <Row>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <Label for="address1">Address 1 <span className="text-danger">*</span></Label>
                                                        <Input type="text" id="address1" value={address1} onChange={(e) => setAddress1(e.target.value)} placeholder="Street, Building" />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <Label for="address2">Address 2</Label>
                                                        <Input type="text" id="address2" value={address2} onChange={(e) => setAddress2(e.target.value)} placeholder="Apt, Suite, Bldg." />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <Label for="townCity">Town/City<span className="text-danger">*</span></Label>
                                                        <Input type="text" id="townCity" value={townCity} onChange={(e) => setTownCity(e.target.value)} placeholder="Street, Building" />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <Label for="postcode">Postcode</Label>
                                                        <Input type="text" id="postcode" value={postcode} onChange={(e) => setPostcode(e.target.value)} placeholder="Apt, Suite, Bldg." />
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <Label for="addcountry">County</Label>
                                                        <Input type="select" id="addcountry" value={addCountry} onChange={(e) => setAddCountry(e.target.value)}>
                                                            <option value="United Kingdom" >United Kingdom</option>
                                                            <option value="United States">United States</option>
                                                            <option value="Canada">Canada</option>
                                                            <option value="India">India</option>
                                                        </Input>
                                                    </FormGroup>
                                                </Col>
                                            </Row> */}

                                            {/* Submit Button */}
                                            <Button color="primary" className="mt-3" onClick={addOrganizationData}>Save Profile</Button>
                                            <Button color="primary" className="mt-3" onClick={copyLink}>Copy Organization URL</Button>
                                        </CardBody>
                                    </Card>
                                </TabPane>
                            </TabContent>
                        </Card>
                    </div>
                </Row>
            </div>
        </div>
    );
};

export default Finance;
